(function () {
    var context = document.getElementById('bitz-topic-context');
    var feed = document.querySelector('.bitz-topic-feed');
    if (!context || !feed || context.dataset.topicSlug === 'bitz-digest') return;

    var topicName = context.dataset.topicName;
    var topicPath = '/tag/' + context.dataset.topicSlug + '/';
    var templates = Array.from(document.querySelectorAll('template.bitz-topic-source'));
    var postCards = Array.from(document.querySelectorAll('.post-feed > .post-card:not(.post-card-large)'));
    if (!templates.length || templates.length !== postCards.length) return;

    function isTopicLink(anchor) {
        if (!anchor) return false;
        try {
            return new URL(anchor.href, location.href).pathname === topicPath;
        } catch (error) {
            return false;
        }
    }

    function sourceUrl(anchor) {
        if (!anchor) return null;
        try {
            var url = new URL(anchor.href, location.href);
            return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : null;
        } catch (error) {
            return null;
        }
    }

    function legacyCards(template) {
        var cards = [];
        var inTopic = false;
        template.content.querySelectorAll('h2, h3').forEach(function (heading) {
            if (heading.tagName === 'H2') {
                inTopic = heading.textContent.trim() === topicName;
                return;
            }
            if (!inTopic || heading.tagName !== 'H3') return;
            var paragraph = heading.nextElementSibling;
            if (!paragraph || paragraph.tagName !== 'P') return;
            var source = paragraph.querySelector('a:last-of-type');
            var href = sourceUrl(source);
            if (!href) return;

            var body = paragraph.cloneNode(true);
            body.querySelector('a:last-of-type').remove();
            var description = body.textContent.replace(/\s*↳\s*$/, '').trim();
            var card = document.createElement('li');
            var metadata = document.createElement('p');
            var topic = document.createElement('a');
            var publisher = document.createElement('a');
            topic.href = topicPath;
            topic.textContent = topicName;
            publisher.href = href;
            publisher.textContent = source.textContent.trim();
            metadata.append(topic, ' ', publisher);

            var title = document.createElement('p');
            var strong = document.createElement('strong');
            var titleLink = document.createElement('a');
            titleLink.href = href;
            titleLink.textContent = heading.textContent.trim();
            strong.appendChild(titleLink);
            title.appendChild(strong);
            card.append(metadata, title);
            if (description) {
                var gloss = document.createElement('p');
                gloss.textContent = description;
                card.appendChild(gloss);
            }
            cards.push(card);
        });
        return cards;
    }

    function digestCards(template) {
        var cards = Array.from(template.content.querySelectorAll('ul > li')).filter(function (item) {
            return isTopicLink(item.querySelector('a'));
        }).map(function (item) {
            return item.cloneNode(true);
        });
        return cards.length ? cards : legacyCards(template);
    }

    function digestDate(template) {
        var match = /^Bitz Digest — ([A-Za-z]+) (\d{1,2}), (\d{4})$/.exec(template.dataset.postTitle || '');
        return match ? match[2] + ' ' + match[1].slice(0, 3) + ' ' + match[3] : template.dataset.postDate;
    }

    var cards = [];
    for (var i = 0; i < templates.length; i++) {
        var matches = digestCards(templates[i]);
        if (!matches.length) return;
        matches.forEach(function (card) {
            var date = document.createElement('p');
            var digest = document.createElement('a');
            date.className = 'bitz-topic-date';
            digest.href = templates[i].dataset.postUrl;
            digest.textContent = 'Digest · ' + digestDate(templates[i]);
            date.appendChild(digest);
            card.appendChild(date);
            cards.push(card);
        });
    }

    feed.querySelector('ul').append.apply(feed.querySelector('ul'), cards);
    feed.setAttribute('aria-label', 'News in ' + topicName);
    feed.hidden = false;
    postCards.forEach(function (card) { card.hidden = true; });
    var fallbackDescription = document.querySelector('.post-card-large .post-card-excerpt');
    if (fallbackDescription && /^A collection of \d+ posts?$/.test(fallbackDescription.textContent.trim())) {
        fallbackDescription.hidden = true;
    }
})();
